export const BROWSER_MAP: { [key: string]: string } = {
  chrome: "Chrome",
  firefox: "Firefox",
  ie: "Internet Explorer",
  edge: "Microsoft Edge",
  opera: "Opera",
  safari: "Safari",
  ios_saf: "iOS",
};
